// extracted by mini-css-extract-plugin
module.exports = {"list":"PaymentOptions_list__vuSK7"};